var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIosSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16C30 23.728 23.735 30 16 30C8.265 30 2 23.728 2 16C2 8.265 8.265 2 16 2C23.735 2 30 8.265 30 16Z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08597 20.8394H8.61506V13.7443H7.08597V20.8394ZM7.84745 12.8139C8.3203 12.8139 8.70103 12.4123 8.70103 11.9103C8.70103 11.3949 8.3203 11 7.84745 11C7.38074 11 7 11.3949 7 11.9103C7 12.4123 7.38074 12.8139 7.84745 12.8139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9577 11.0201C11.3723 11.0201 9.75113 12.9411 9.75113 16.0134C9.75113 19.0857 11.3723 21 13.9577 21C16.5368 21 18.158 19.0857 18.158 16.0134C18.158 12.9411 16.5368 11.0201 13.9577 11.0201ZM13.9577 12.4926C15.5359 12.4926 16.543 13.8581 16.543 16.0134C16.543 18.162 15.5359 19.5274 13.9577 19.5274C12.3733 19.5274 11.3723 18.162 11.3723 16.0134C11.3723 13.8581 12.3733 12.4926 13.9577 12.4926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0608 18.1218C19.1283 19.9023 20.467 21 22.5058 21C24.649 21 26 19.8487 26 18.0147C26 16.5756 25.2385 15.7657 23.4392 15.3173L22.4198 15.0629C21.3329 14.7818 20.8846 14.407 20.8846 13.7644C20.8846 12.9612 21.5601 12.4257 22.5611 12.4257C23.5743 12.4257 24.2683 12.9679 24.342 13.8715H25.8526C25.8158 12.1714 24.5262 11.0201 22.5734 11.0201C20.6451 11.0201 19.2757 12.178 19.2757 13.8916C19.2757 15.2704 20.0495 16.1272 21.6829 16.5355L22.8313 16.83C23.9489 17.1178 24.4034 17.5194 24.4034 18.2155C24.4034 19.0187 23.6603 19.5944 22.5918 19.5944C21.511 19.5944 20.6942 19.012 20.596 18.1218H19.0608Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosSvgrepoCom);
export default __webpack_public_path__ + "static/media/ios-svgrepo-com.25b40dc7c9f81bbd68dd882c05f8cd97.svg";
export { ForwardRef as ReactComponent };